var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":_vm.path_definition(_vm.points),"stroke":_vm.stroke,"stroke-width":"2","fill":_vm.graph_fill}})}
var staticRenderFns = []

export { render, staticRenderFns }